/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleResponse } from './RoleResponse';
import {
    RoleResponseFromJSON,
    RoleResponseFromJSONTyped,
    RoleResponseToJSON,
    RoleResponseToJSONTyped,
} from './RoleResponse';
import type { PermissionResponse } from './PermissionResponse';
import {
    PermissionResponseFromJSON,
    PermissionResponseFromJSONTyped,
    PermissionResponseToJSON,
    PermissionResponseToJSONTyped,
} from './PermissionResponse';

/**
 * 
 * @export
 * @interface AdGroupDetailResponse
 */
export interface AdGroupDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof AdGroupDetailResponse
     */
    adGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdGroupDetailResponse
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdGroupDetailResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdGroupDetailResponse
     */
    name?: string | null;
    /**
     * 
     * @type {Array<RoleResponse>}
     * @memberof AdGroupDetailResponse
     */
    roles?: Array<RoleResponse> | null;
    /**
     * 
     * @type {Array<PermissionResponse>}
     * @memberof AdGroupDetailResponse
     */
    permissions?: Array<PermissionResponse> | null;
    /**
     * 
     * @type {any}
     * @memberof AdGroupDetailResponse
     */
    userCount?: any | null;
}

/**
 * Check if a given object implements the AdGroupDetailResponse interface.
 */
export function instanceOfAdGroupDetailResponse(value: object): value is AdGroupDetailResponse {
    return true;
}

export function AdGroupDetailResponseFromJSON(json: any): AdGroupDetailResponse {
    return AdGroupDetailResponseFromJSONTyped(json, false);
}

export function AdGroupDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdGroupDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'adGroupId': json['adGroupId'] === undefined ? undefined : json['adGroupId'] === null ? null : json['adGroupId'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'roles': json['roles'] === undefined ? undefined : json['roles'] === null ? null : ((json['roles'] as Array<any>).map(RoleResponseFromJSON)),
        'permissions': json['permissions'] === undefined ? undefined : json['permissions'] === null ? null : ((json['permissions'] as Array<any>).map(PermissionResponseFromJSON)),
        'userCount': json['userCount'] === undefined ? undefined : json['userCount'] === null ? null : json['userCount'],
    };
}

export function AdGroupDetailResponseToJSON(json: any): AdGroupDetailResponse {
    return AdGroupDetailResponseToJSONTyped(json, false);
}

export function AdGroupDetailResponseToJSONTyped(value?: AdGroupDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adGroupId': value['adGroupId'],
        'description': value['description'],
        'isActive': value['isActive'],
        'name': value['name'],
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(RoleResponseToJSON)),
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(PermissionResponseToJSON)),
        'userCount': value['userCount'],
    };
}

